import React from 'react';

interface CRMIconProps {
  fill: string;
  height: string;
  width: string;
}

export function CRMIcon({ fill, height, width }: CRMIconProps) {
  return (
    <svg width={height} height={width} viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.9533 14.8044C28.1739 15.5838 26.8748 15.5838 26.0954 14.8044L17.1621 5.89111L3.0727 19.9606L1.75368 18.7015C-0.584562 16.3633 -0.584562 12.5661 1.75368 10.2279L10.2273 1.75422C12.5656 -0.584031 16.3627 -0.584031 18.701 1.75422L28.9533 11.9865C29.7327 12.766 29.7327 14.025 28.9533 14.8044ZM30.3522 10.5676C31.9111 12.1264 31.9111 14.6645 30.3522 16.2234C27.8141 18.7615 25.1361 16.663 24.6965 16.2234L17.1821 8.709L6.05046 19.8407C5.27105 20.6201 5.27105 21.8791 6.05046 22.6585C6.82988 23.438 8.08893 23.438 8.88833 22.6585L18.1214 13.4255L19.5403 14.8444L10.3073 24.0775C9.52785 24.8569 9.52785 26.1159 10.3073 26.8954C11.0867 27.6748 12.3457 27.6748 13.1451 26.8954L22.3782 17.6623L23.7972 19.0812L14.5641 28.3143C13.7847 29.0937 13.7847 30.3528 14.5641 31.1322C15.3435 31.9116 16.6025 31.9116 17.382 31.1322L26.615 21.8991L28.034 23.318L18.8009 32.5511C18.0215 33.3305 18.0215 34.5896 18.8009 35.369C19.5803 36.1484 20.8394 36.1484 21.6188 35.369L38.2463 18.7015C40.5846 16.3633 40.5846 12.5661 38.2463 10.2279L29.7727 1.75422C27.4744 -0.544061 23.7572 -0.584031 21.4189 1.63431L30.3522 10.5676Z"
        fill={fill}
      />
    </svg>
  );
}
